import { render, staticRenderFns } from "./AddToPortfolios.vue?vue&type=template&id=53ea5f74&scoped=true&"
import script from "./AddToPortfolios.vue?vue&type=script&lang=js&"
export * from "./AddToPortfolios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ea5f74",
  null
  
)

export default component.exports